<router-outlet></router-outlet>

<p-confirmDialog #cd styleClass="w-30rem h-13rem">
    <ng-template pTemplate="icon"></ng-template>
    <ng-template pTemplate="footer">
        <div class="flex w-full gap-2 justify-content-end">
            <div class="flex-1">
                <p-button label="No" (onClick)="cd.reject()" [outlined]="true" styleClass="w-full"></p-button>
            </div>
            <div class="flex-1">
                <p-button label="Yes" (onClick)="cd.accept()" styleClass="w-full"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

<p-toast [preventOpenDuplicates]="true" position="bottom-center" [life]="2000" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="flex w-full gap-3 align-items-center">
            <img [src]="statusIcons[message.severity].src" width="32" height="32" alt="status icon" />
            <div class="flex flex-column">
                <span class="text-lg text-bold">{{ message.summary }}</span>
                <span class="text-xs"
                    >{{ message.detail }}

                    @if (message?.data?.link) {
                        :
                        <a
                            [href]="message.data.link.url"
                            [target]="message.data.link.target || '_self'"
                            class="cursor-pointer text-primary-900 text-xs underline"
                        >
                            {{ message.data.link.text }}
                        </a>
                    }
                </span>
            </div>
        </div>
    </ng-template>
</p-toast>

@if (!loaderComponent.disabled) {
    <ng-http-loader
        [backdrop]="true"
        [backdropBackgroundColor]="'var(--overlay-background-color)'"
        [debounceDelay]="100"
        opacity="1"
        [entryComponent]="loaderComponent"
    >
    </ng-http-loader>
}
